import { type Dispatch } from "@reduxjs/toolkit";
import groupsDataService from "features/People/services/groupsDataService";
import { fetchBegin, fetchFailure, fetchSuccess } from "../slices/groupMembersAssignmentSlice";
import { type Filters } from "../../../../../../utils/queryUtils";
import { escapeTerm } from "../../../../../../utils/searchUtils";
import KnownHttpHeaders from "../../../../../Application/services/knownHttpHeaders";

interface GetGroupMembersAssignmentParams {
  groupId: number;
  skip: number;
  top: number;
  orderByParams?: string;
  filter?: string | Filters;
  search?: string;
}

export const fetchGroupUsersAssignment =
  ({ groupId, skip, top, orderByParams, filter, search }: GetGroupMembersAssignmentParams) =>
  async (dispatch: Dispatch) => {
    dispatch(fetchBegin());
    try {
      const searchTerm = escapeTerm(search);
      const { data, headers } = searchTerm
        ? await groupsDataService.getGroupUsersToAddV2([groupId], skip, top, orderByParams, filter, searchTerm)
        : await groupsDataService.getGroupUsersToAdd([groupId], skip, top, orderByParams, filter);

      dispatch(fetchSuccess({ items: data, totalCount: parseInt(headers[KnownHttpHeaders.RecordsCount]) }));
    } catch (e) {
      dispatch(fetchFailure(e as Error));
    }
  };
